import { API_URLS } from "src/utils/API_URLS";
import { GlobalMetaFields } from "src/app/SettingsModal/tabs/Extensions/components/MetaFieldMembers/GlobalMetaFieldList";
import { CreatorContentMonitor, WsExtension } from "src/types";
import * as actionTypes from "./extensionTypes";

export function getExtensionList(projectId: string) {
  const url = API_URLS.getProjectExtensionsList.replace(
    ":projectUuid:",
    projectId,
  );

  return {
    type: actionTypes.GET_EXTENSION_LIST,
    payload: {
      request: { url },
    },
  };
}

export function getWorkspaceExtensionList(wsWorkspaceUuid: string) {
  const url = API_URLS.getWorkspaceExtensionsList.replace(
    ":wsWorkspaceUuid:",
    wsWorkspaceUuid,
  );

  return {
    type: actionTypes.GET_WORKSPACE_EXTENSION_LIST,
    payload: {
      request: { url },
    },
  };
}

export function setExtensionList(extensionList: WsExtension[]) {
  return { type: actionTypes.SET_EXTENSION_LIST, payload: { extensionList } };
}

export function setWorkspaceExtensionList(extensionList: WsExtension[]) {
  return {
    type: actionTypes.SET_WORKSPACE_EXTENSIONS_LIST,
    payload: { extensionList },
  };
}

export function clearExtensionList() {
  return {
    type: actionTypes.CLEAR_EXTENSION_LIST,
  };
}

export function setGlobalMetaFieldList(
  globalMetaFieldList: GlobalMetaFields[],
) {
  return {
    type: actionTypes.SET_GLOBAL_TASK_META_VALUE_LIST,
    payload: { globalMetaFieldList },
  };
}

export function setIsGlobalMetaFieldListLoading(loading: boolean) {
  return {
    type: actionTypes.SET_IS_GLOBAL_TASK_META_VALUE_LIST_LOADING,
    payload: { loading },
  };
}

export function getAvailableProjectMetaFields(wsProjectUuid: string) {
  const url = API_URLS.getAvailableFields.replace(
    ":projectUuid:",
    wsProjectUuid,
  );
  return {
    type: actionTypes.GET_AVAILABLE_PROJECT_META_FIELDS,
    payload: {
      request: { url },
    },
  };
}

export function getAvailableWorkspaceGlobalTaskMetaFields(
  wsWorkspaceUuid: string,
) {
  const url = API_URLS.getWorkspaceAvailableFields.replace(
    ":wsWorkspaceUuid:",
    wsWorkspaceUuid,
  );
  return {
    type: actionTypes.GET_AVAILABLE_WORKSPACE_GLOBAL_TASK_META_FIELDS,
    payload: {
      request: { url },
    },
  };
}

export function clearAvailableProjectMetaFields() {
  return {
    type: actionTypes.CLEAR_AVAILABLE_PROJECT_META_FIELDS,
  };
}

export function clearAvailableWorkspaceGlobalTaskMetaFields() {
  return {
    type: actionTypes.CLEAR_AVAILABLE_WORKSPACE_GLOBAL_TASK_META_FIELDS,
  };
}

export function getCreatorContentMonitoringList(wsProjectUuid: string) {
  const url = API_URLS.getCreatorContentMonitorsList.replace(
    ":wsProjectUuid:",
    wsProjectUuid,
  );
  return {
    type: actionTypes.GET_CREATOR_CONTENT_MONITORS_LIST,
    payload: {
      request: { url },
    },
  };
}

export function addCreatorContentMonitor(data: CreatorContentMonitor) {
  return {
    type: actionTypes.ADD_CREATOR_CONTENT_MONITOR,
    payload: {
      request: {
        method: "POST",
        url: API_URLS.addCreatorContentMonitor,
        data,
      },
    },
  };
}

export function clearNewlyAddedMonitorUuid() {
  return {
    type: actionTypes.CLEAR_NEWLY_ADDED_MONITOR_UUID,
  };
}

export function updateCreatorContentMonitor(data: CreatorContentMonitor) {
  return {
    type: actionTypes.UPDATE_CREATOR_CONTENT_MONITOR,
    payload: {
      request: {
        method: "POST",
        url: API_URLS.updateCreatorContentMonitor,
        data,
      },
    },
  };
}

export function deleteCreatorContentMonitor(data: {
  uuid: string;
  wsProjectUuid: string;
}) {
  return {
    type: actionTypes.DELETE_CREATOR_CONTENT_MONITOR,
    payload: {
      request: {
        method: "DELETE",
        url: API_URLS.deleteCreatorContentMonitor,
        data,
      },
    },
  };
}
